const requestJson = async (path, options = {}) => {
  const response = await fetch(path, {
    credentials: "same-origin",
    ...options,
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(options.headers || {}),
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.error || "The cloud profile request failed.");
    error.status = response.status;
    error.body = body;
    throw error;
  }
  return body;
};

export const accountSession = () => requestJson("/api/account/session");

export const registerCloudAccount = ({ email, password, deviceId, initialData }) =>
  requestJson("/api/account/register", {
    method: "POST",
    body: JSON.stringify({ email, password, deviceId, initialData }),
  });

export const loginCloudAccount = ({ email, password, deviceId }) =>
  requestJson("/api/account/login", {
    method: "POST",
    body: JSON.stringify({ email, password, deviceId }),
  });

export const logoutCloudAccount = () =>
  requestJson("/api/account/logout", { method: "POST", body: "{}" });

export const deleteCloudAccount = (password) =>
  requestJson("/api/account", {
    method: "DELETE",
    body: JSON.stringify({ password }),
  });

export const fetchCloudData = () => requestJson("/api/data");

export const saveCloudData = ({ data, expectedRevision, deviceId }) =>
  requestJson("/api/data", {
    method: "PUT",
    body: JSON.stringify({ data, expectedRevision, deviceId }),
  });
